import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { ContactApi } from "../../../Shared/Constants/api";

export const exportDataToXls = async (id) => {
  try {
    let response = await axiosInstance.post(`${ContactApi}/export-xls/${id}`);

    return response.data;
  } catch (error) {
    return error?.response ? error?.response : { message: genericError };
    // throw error; // Re-throw error for further handling if needed
  }
};
